import React from "react";
import Loader from "../../components/loader/loader";
import Table from "../../components/table/table";
import TableCellRenderer from "../../components/table/table-cell-renderer";
import { GET_USERS_QUERY } from "../../graphql/queries/users";
import { useQuery } from "@apollo/client";

const UsersPage = () => {
  const { data, loading, error } = useQuery(GET_USERS_QUERY);

  if (error) {
    return <div className="display-page__error">Something went wrong</div>;
  }

  return (
    <div className="display-page">
      <div className="display-page__title">Users</div>
      <div className="details-page__table">
        {loading ? (
          <Loader sizeClass={"size--medium"} />
        ) : (
          <Table
            data={data.users}
            columns={[
              {
                field: "fullName",
                title: "Full Name",
                showOnMobile: true,
                hideMobileUp: false,
                render: ({ client }) => {
                  return (
                    <TableCellRenderer
                      firstItem={`${client?.name ?? ""} ${client?.surname ?? ""}`}
                    />
                  );
                },
              },
              {
                field: "email",
                title: "Email",
                showOnMobile: true,
                hideMobileUp: false,
                render: ({ email }) => {
                  return <TableCellRenderer firstItem={`${email}`} />;
                },
              },
              {
                field: "role",
                title: "Role",
                showOnMobile: true,
                hideMobileUp: false,
                render: ({ role }) => {
                  return <TableCellRenderer firstItem={`${role}`} />;
                },
              },
            ]}
          />
        )}
      </div>
    </div>
  );
};

export default UsersPage;
